const inputEmail = document.querySelector('#email');
const inputPassword = document.querySelector('#password');
const loginButton = document.querySelector('#submitForm');
const nextButton = document.querySelector('#nextFieldLogin');
const loginLoader = document.querySelector('#login-loader');
const signInFormMobile = document.querySelector('#sign-in-form-container');
const signUpButton = document.querySelector('#submit-signup-app-form');
const inputEmailSignUp = document.querySelector('#email-signup');
const proceedSignUpButton = document.querySelector('#proceed-sign-up');
const partOfCompanyButton = document.querySelector('#part-of-company');
const domainBackToLoginButton = document.querySelector('#back-to-login');
const nextLoader = document.querySelector('#next-loader');
const nextText = document.querySelector('#next-text');

/**
 * Inicializando o js da formulário
 * da tela de login
 */
function init() {
  const formLogin = document.querySelector('#formLogin');
  const formCadastro = $('#form-cadastro');

  if (formCadastro.length && formCadastro.data('createAccount')) {
    applyListenerSubmitSignUp();
    proceedSignUpButton.addEventListener('click', handlerSubmitProceedSignUp);
    partOfCompanyButton.addEventListener('click', handlerPartOfCompany);
  }

  if (!document.body.contains(formLogin)) {
    return;
  }

  applyListenerNextStep();
  applyListenerSubmitLogin();

  if (!formLogin.dataset.loginMobile) {
    applyListenerSubmitSignUp();
    domainBackToLoginButton.addEventListener('click', handlerReturnForLogin);
  }

  // Mostra formulário do login mobile
  if (loginLoader) {
    loginLoader.classList.add('hidden');
    signInFormMobile.classList.remove('hidden');
  }

  // Remove cacheamento do usuário do localStorage (utilizado no React)
  localStorage.removeItem('@vexpenses:cartoes:authenticatedUser');
}

function show(id) {
  const $element = $(id);

  $element
    .removeClass('fadeOutDown')
    .addClass('fadeInUp')
    .removeClass('hidden');

  $element
    .find('[type=email]')
    .trigger('focus')
    .trigger('select');
}

function hide(id) {
  const $element = $(id);
  if (!$element.hasClass('hidden')) {
    $element
      .removeClass('fadeInUp')
      .addClass('fadeOutDown')
      .addClass('hidden');
  }
  $element
    .find('[type=email]')
    .trigger('blur');
}

/**
 * Aplicando os listener nos elementos de login que disparam
 * a validação para seguir com os próximos passos da autenticação
 */
function applyListenerNextStep() {
  nextButton.addEventListener('click', handlerNextStepLogin);
  inputEmail.addEventListener('keydown', (event) => {
    if (event.keyCode === 13) {
      return handlerNextStepLogin(event);
    }
  });
}

/**
 * Aplicando o listeners dos elemento de login que disparam
 * o submit do formulário
 */
function applyListenerSubmitLogin() {
  loginButton.addEventListener('click', handlerSubmitLogin);

  inputPassword.addEventListener('keydown', (event) => {
    if (event.keyCode === 13) {
      return handlerSubmitLogin(event);
    }
  });
}

/**
 * Aplicando o listeners dos elemento de cadastro que disparam
 * o submit do formulário
 */
function applyListenerSubmitSignUp() {
  signUpButton.addEventListener('click', handlerSubmitSignUp);
  inputEmailSignUp.addEventListener('keydown', (event) => {
    if (event.keyCode === 13) {
      return handlerSubmitSignUp(event);
    }
  });
}

/**
 * Manipulador do evento de preenchimento do e-mail
 * para seguir com o prenchimento dos demais campos
 * necessários para a autenticação
 *
 * @param {event} event
 */
function handlerNextStepLogin(event) {
  const $inputEmail = $(inputEmail);
  const email = inputEmail.value;
  nextText.classList.add('hidden');
  nextLoader.classList.remove('hidden');

  if (!$inputEmail.valid()) {
    nextText.classList.remove('hidden');
    nextLoader.classList.add('hidden');
    return;
  }

  // Esconde formulário do login mobile e mostra loader
  if (loginLoader) {
    loginLoader.classList.remove('hidden');
    signInFormMobile.classList.add('hidden');
  }

  checkCompanyUseAdfs(email)
    .done((data) => {
      if (data.utilizaAdfsSaml) {
        window.location.href = data.endpoint;
        return;
      }

      nextButton.classList.add('hidden');

      // Esconde loader e mostra formulário do login mobile
      if (loginLoader) {
        loginLoader.classList.add('hidden');
        signInFormMobile.classList.remove('hidden');
      }

      nextText.classList.remove('hidden');
      nextLoader.classList.add('hidden');
      showFieldsWebLogin();
    })
    .fail(() => {
      nextButton.classList.add('hidden');
      nextText.classList.remove('hidden');
      nextLoader.classList.add('hidden');
      // Esconde loader e mostra formulário do login mobile
      if (loginLoader) {
        loginLoader.classList.add('hidden');
        signInFormMobile.classList.remove('hidden');
      }

      showFieldsWebLogin();
    });
}

/**
 * Manipulador do evento de realizar o submit do
 * formulário de login, antes de realizar o submit
 * ainda é verificado mais uma vez se o usuário
 * deve ser redirecionado para o adfs
 *
 * @param {Event} event
 */
function handlerSubmitLogin(event) {
  event.preventDefault();
  const email = inputEmail.value;
  const signInLoader = $('#sign-in-loader');
  const signInText = $('#sign-in-text');

  signInLoader.removeClass('hidden');
  signInText.addClass('hidden');

  // Esconde formulário do login mobile e mostra loader
  if (loginLoader) {
    loginLoader.classList.remove('hidden');
    signInFormMobile.classList.add('hidden');
  }

  if (inputEmail.disabled) {
    inputEmail.removeAttribute('disabled');
  }

  checkCompanyUseAdfs(email)
    .done((data) => {
      if (data.utilizaAdfsSaml) {
        window.location.href = data.endpoint;
        return;
      }
    })
    .always(() => {
      const $formLogin = $('#formLogin');
      if (!$formLogin.valid()) {
        signInText.removeClass('hidden');
        signInLoader.addClass('hidden');
        return;
      }

      if (loginButton.classList.contains('loginCaptcha')) {
        grecaptcha.execute();
      } else {
        $formLogin.trigger('submit');
      }
    });
}

/**
 * Manipulador do evento de realizar o submit do
 * formulário de cadastro, antes de realizar o submit
 * é verificado se o dominio do e-mail ja existe
 *
 * @param {Event} event
 */
function handlerSubmitSignUp(event) {
  event.preventDefault();
  const email = inputEmailSignUp.value;

  checkEmailDomainExists(email)
    .done((data) => {
      if (data.exists) {
        const newHtml = $('#p-domain-exists').html() + data.domain.split('.')[0] + '.'
        $('#p-domain-exists').html(newHtml);
        hide('#sign-up')
        show('#email-domain-exists')
      } else {
        const formSignUp = $('#form-cadastro');
        if (!formSignUp.valid()) {
          return;
        }
        const widgetId = formSignUp.data('recaptchaWidgetId');

        // caso não exista resposta desse recaptcha, faz o submit executando ele
        // se existir, faz submit no form diretamente
        if (!grecaptcha.getResponse(widgetId)) {
          // removendo data que impede submit pelo recaptcha
          formSignUp.find('[data-recaptcha-disable-submit]').prop('data-recaptcha-disable-submit', false);
          // executando recaptcha e fazendo submit do form por ele
          grecaptcha.execute(widgetId);
        } else {
          formSignUp.trigger('submit');
        }
      }
    });
}

/**
 * Manipulador do evento de realizar o submit do
 * formulário de cadastro, quando o usuario insiste em
 * prosseguir com o cadastro
 */
function handlerSubmitProceedSignUp() {
  $('#hiddenDomainExists').val('true');
  hide('#email-domain-exists');
  hide('#rowSignUpButtons div');
  show($('#sign-up'))
  const formSignUp = $('#form-cadastro');
  if (!formSignUp.valid()) {
    return;
  }
  const widgetId = formSignUp.data('recaptchaWidgetId');

  // caso não exista resposta desse recaptcha, faz o submit executando ele
  // se existir, faz submit no form diretamente
  if (!grecaptcha.getResponse(widgetId)) {
    // removendo data que impede submit pelo recaptcha
    formSignUp.find('[data-recaptcha-disable-submit]').prop('data-recaptcha-disable-submit', false);
    // executando recaptcha e fazendo submit do form por ele
    grecaptcha.execute(widgetId);
  } else {
    formSignUp.trigger('submit');
  }
}

/**
 * Manipulador do evento que exibe a mensagem caso o usuario
 * afirme fazer parte de uma empresa que ja utiliza o vex
 */
function handlerPartOfCompany() {
  hide('#email-domain-exists');
  show('#company-uses-vexpenses');
}

/**
 * Manipulador do evento que retorna para a tela de login após exibir
 * a mensagem para o usuario
 */
function handlerReturnForLogin() {
  hide('#email-domain-exists');
  show('#sign-in');
}

/**
 * Exbir os demais campos após a verificação do e-mail
 *  para continuar o fluxo de login utilizando o VExpenses
 * para autenticar
 */
function showFieldsWebLogin() {
  const hiddenContent = document.querySelectorAll('.login__content-hidden');

  hiddenContent.forEach(item => {
    item.classList.remove('hidden');
  });

  /**
   * Verificação para impedir que o focus no input de senha seja
   * aplicado no login mobile, pois pode gerar o problema de duplo clique
   * para acessar o campo
   */
  if (!inputPassword.getAttribute('data-mobile')) {
    inputPassword.focus();
  }
}

/**
 * Envio da request para verificar se a empresa do usuário
 * utiliza a autenticação com Active Directory Federation
 *
 * @param {string} email
 */
function checkCompanyUseAdfs(email) {
  return $.ajax({
    method: 'POST',
    url: route('app.saml.service-provider.check'),
    data: {
      email
    }
  });
}

/**
 * Envio da request para verificar se existe um outro email
 * com o mesmo dominio do utilizado no cadastro
 *
 * @param {string} email
 */
function checkEmailDomainExists(email) {
  return $.ajax({
    method: 'GET',
    url: route('app.auth.email-domain'),
    data: {
      email
    }
  });
}

module.exports = {
  init: init,
  url: [
    route('app.login'),
    route('app.login-mobile'),
    route('app.create-account')
  ],
}
